/** API route map: URLS.Controller.Company */
export const Company = {
      Name: 'Company/',
      GetCompanyByDomainName: 'GetCompanyByEmployeeDomainName',
};
